import React from "react";
import { newsData, newsTypes } from "./newsData";
import { AuroraBackground } from "../components/AuroraBackground";

require("../../css/news/news.css");

export const NewsComponent = ({ type }) => {
  const sortedData = newsData[type].sort((a, b) => {
    return new Date(b.date) - new Date(a.date);
  });
  return (
    <div id="news-component" className="news-page md-font aurora-background">
      <AuroraBackground particleCount={8} />
      
      <div className="news-title-container">
        <h1 className="news-title xl-font">{newsTypes[type]}</h1>
      </div>

      <div className="news-container">
        {sortedData.map((data) => {
          return (
            <div key={data.title} className="news-card">
              <a target="_blank" href={data.link} rel="noopener noreferrer">
                <div className="img-container">
                  <img src={data.href} alt={data.title}></img>
                </div>
              </a>
              <a href={data.link} target="_blank" rel="noopener noreferrer">
                <h2>{data.title}</h2>
              </a>
              <p className="news-date">{data.date}</p>
              {data.location && <p className="news-location">{data.location}</p>}
              {data.type && <p className="news-type">{data.type}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
};
